import { Menu as BaseMenu } from '@base-ui/react/menu'

import { cn } from '@gto/ui/cn'
import { typography } from '@gto/ui/typography'

/**
 * Uppercase section header rendered above a `Group` of items. Matches the
 * `DISPLAY` / `GRID VIEW` headers in the design.
 */
export const GroupLabel = ({ className, ...props }: BaseMenu.GroupLabel.Props) => {
  return (
    <BaseMenu.GroupLabel
      className={cn(
        typography['table/header-xs'],
        'flex h-5 select-none items-center px-2 text-text-secondary opacity-50',
        className,
      )}
      {...props}
    />
  )
}
